var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSingleZeroDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 17,
    viewBox: "0 0 8 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07609 5.38835H6.66703C6.88762 5.38851 7.10473 5.44337 7.29891 5.54802C7.4931 5.65268 7.6583 5.80385 7.77972 5.98801C7.90115 6.17218 7.975 6.38358 7.99468 6.60329C8.01436 6.823 7.97924 7.04416 7.89248 7.24697L4.37088 15.4667C4.28586 15.6635 4.13565 15.8251 3.94551 15.9241C3.75538 16.0232 3.53692 16.0537 3.32691 16.0106C3.11689 15.9675 2.92813 15.8534 2.7924 15.6874C2.65666 15.5215 2.58222 15.3138 2.58162 15.0994V8.94552L1.28948 8.9055C0.943456 8.89396 0.615478 8.74834 0.374853 8.49942C0.134228 8.2505 -0.000192185 7.91777 2.06239e-07 7.57156V2.30428C2.06239e-07 1.95049 0.14054 1.6112 0.390702 1.36104C0.640864 1.11088 0.980157 0.970337 1.33394 0.970337L3.74215 0.970337C4.09593 0.970337 4.43522 1.11088 4.68538 1.36104C4.93555 1.6112 5.07609 1.95049 5.07609 2.30428V5.38835Z",
    fill: "#7B7C7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSingleZeroDay);
export default ForwardRef;